/**
 * Permission Store
 * FSD: features/auth/stores
 *
 * 권한 정보 상태 관리
 */

import { create } from "zustand";
import { Permission } from "./permission-types";

interface PermissionStore {
  permissionsState: Permission[] | null;
  setPermissionsState: (permissions: Permission[] | null) => void;
  getPermissionByMenuName: (pmsMenuName: string) => Permission | undefined;
}

export const usePermissionStore = create<PermissionStore>((set, get) => ({
  permissionsState: null,
  setPermissionsState: (permissions) => set({ permissionsState: permissions }),
  getPermissionByMenuName: (pmsMenuName: string) => {
    const permissions = get().permissionsState;
    if (!permissions) {
      return undefined;
    }
    return permissions.find(
      (permission) => permission.pmsMenuName === pmsMenuName
    );
  },
}));
